import { MeetingPrepLearnedDefault as MeetingPrepLearnedDefaultNode } from "@acto/gql/graphql";

export default class MeetingPrepLearnedDefault {
  constructor(
    public readonly id: string,
    public readonly cardKey: string,
    public readonly learnedAfterHides: number,
    /** The api's zone-less UTC wall time. */
    public readonly suppressedAt: string | null = null,
  ) {}

  static fromGraphql(
    data: Pick<MeetingPrepLearnedDefaultNode, "id" | "cardKey" | "learnedAfterHides" | "suppressedAt">,
  ): MeetingPrepLearnedDefault {
    return new MeetingPrepLearnedDefault(data.id, data.cardKey, data.learnedAfterHides, data.suppressedAt ?? null);
  }

  /** Also applies when either time is missing or unparseable. */
  appliesToPrepGeneratedAt(generatedAt: string | null): boolean {
    const learnedAt = this.suppressedAt ? Date.parse(`${this.suppressedAt}Z`) : NaN;
    const preparedAt = generatedAt ? Date.parse(generatedAt) : NaN;
    if (Number.isNaN(learnedAt) || Number.isNaN(preparedAt)) return true;

    return learnedAt < preparedAt;
  }
}
